type StringOrElement = string | JSX.Element;

interface InterpolationObj {
  [k: string]: StringOrElement;
}

export function replaceBetween(
  str: string,
  obj: InterpolationObj,
  opening: string = '{{',
  closing: string = '}}'
): StringOrElement[] | string {
  let builder: StringOrElement[] = [];
  let hasElement = false;

  for (let i = 0; i < str.length; i++) {
    if (str.startsWith(opening, i)) {
      const start = i + opening.length;

      while (!str.startsWith(closing, i)) {
        if (i > str.length) {
          throw new Error(
            `String has opening sequence "${opening}", but no closing sequence "${closing}" found.`
          );
        }
        i++;
      }
      const key = str.slice(start, i);

      if (!obj.hasOwnProperty(key)) {
        throw new Error(
          `Key "${key}" does not exist in the interpolation obj, only have these keys: ${JSON.stringify(
            Object.keys(obj)
          )}`
        );
      }

      if (typeof obj[key] !== 'string') {
        hasElement = true;
      }
      builder.push(obj[key]);

      i += closing.length - 1;
    } else {
      builder.push(str[i]);
    }
  }

  if (hasElement) {
    return builder;
  }
  return builder.join('');
}
export function getUrlExtension(url) {
  return url
    .split(/\#|\?/)[0]
    .split('.')
    .pop()
    .trim();
}
/**
 * Slice a string from start to a particular position, and optionally add a
 * suffix at the end of the sliced result
 * maximum length of output string is bounded by the `to` param
 * `to` MUST BE LARGER THAN `postFix`
 */
export function cutString(string, to, postFix = '...') {
  if (to <= postFix.length)
    throw new Error(
      'output string after truncation must be longer than postfix'
    );
  return string.length < to
    ? string
    : string.slice(0, to - postFix.length) + postFix;
}



// WEBPACK FOOTER //
// ./app/utils/strings.ts